// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { text } from '../../tokens/themeColors/text';
export var appBarColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var tx = text(mode);
    return {
        background: bg.level0,
        border: bd.soft,
        text: tx.secondary,
        navItem: {
            text: tx.secondary,
            active: {
                text: tx.primary
            },
            hover: {
                background: bg.state.hover0
            }
        }
    };
};

//# sourceMappingURL=appBarColors.js.map